import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { RouteErrorBoundary } from './app/RouteErrorBoundary';
import './design-system/tokens.css';
import './design-system/base.css';
import './styles/application.css';
import './styles/launch-hardening.css';
import { AuthProvider } from './auth/session';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouteErrorBoundary scope="app"><AuthProvider><App /></AuthProvider></RouteErrorBoundary>
  </StrictMode>,
);
